export const WebchatSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": [
        "Organization",
        "Corporation"
      ],
      "@id": "https://navatel.ir/#organization",
      "name": "نواتل",
      "alternateName": [
        "Navatel",
        "شبکه گستران آریا سامانه"
      ],
      "legalName": "شرکت مهندسی شبکه گستران آریا سامانه",
      "url": "https://navatel.ir/",
      "logo": {
        "@type": "ImageObject",
        "@id": "https://navatel.ir/#logo",
        "url": "https://navatel.ir/_ipx/q_80&s_150x72/img/logo-modal.webp",
        "width": 150,
        "height": 72,
        "caption": "لوگوی رسمی نواتل"
      },
      "telephone": "+98-21-82800000"
    },
    {
      "@type": "WebSite",
      "@id": "https://navatel.ir/#website",
      "url": "https://navatel.ir/",
      "name": "نواتل",
      "alternateName": "Navatel",
      "inLanguage": "fa-IR",
      "publisher": {
        "@id": "https://navatel.ir/#organization"
      }
    },
    {
      "@type": "WebPage",
      "@id": "https://navatel.ir/products/webchat/#webpage",
      "url": "https://navatel.ir/products/webchat/",
      "name": "چت آنلاین سایت؛ گفتگوی زنده با بازدیدکنندگان سایت",
      "description": "با وب چت آنلاین نواتل، بازدیدکنندگان سایت را به مشتری تبدیل کنید. یکپارچه با CRM و مرکز تلفن ابری، بدون نیاز به کدنویسی | مشاوره رایگان",
      "inLanguage": "fa-IR",
      "isPartOf": {
        "@id": "https://navatel.ir/#website"
      },
      "about": {
        "@id": "https://navatel.ir/products/webchat/#service"
      },
      "mainEntity": {
        "@id": "https://navatel.ir/products/webchat/#service"
      },
      "primaryImageOfPage": {
        "@id": "https://navatel.ir/products/webchat/#primaryimage"
      },
      "breadcrumb": {
        "@id": "https://navatel.ir/products/webchat/#breadcrumb"
      },
      "publisher": {
        "@id": "https://navatel.ir/#organization"
      }
    },
    {
      "@type": "ImageObject",
      "@id": "https://navatel.ir/products/webchat/#primaryimage",
      "url": "https://navatel.ir/img/new/webchat/hero-laptop.webp",
      "contentUrl": "https://navatel.ir/img/new/webchat/hero-laptop.webp",
      "width": 1800,
      "height": 1080,
      "caption": "پنل و ویجت چت آنلاین سایت نواتل"
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://navatel.ir/products/webchat/#breadcrumb",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "خانه",
          "item": "https://navatel.ir/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "محصولات",
          "item": "https://navatel.ir/products/"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "چت آنلاین سایت",
          "item": "https://navatel.ir/products/webchat/"
        }
      ]
    },
    {
      "@type": [
        "Product",
        "SoftwareApplication"
      ],
      "@id": "https://navatel.ir/products/webchat/#service",
      "name": "چت آنلاین سایت نواتل",
      "alternateName": [
        "سرویس چت آنلاین سایت نواتل",
        "وب چت نواتل",
        "Navatel Web Chat"
      ],
      "description": "چت آنلاین سایت نواتل یک سرویس ابری گفتگوی زنده برای سایت کسب‌وکارهاست که با یک اسکریپت کوتاه، بدون کدنویسی و در کمتر از ۵ دقیقه نصب می‌شود. گفتگوها با سه روش توزیع بین اپراتورها تقسیم می‌شوند، همراه با کل تاریخچه به اپراتور یا دپارتمان دیگر منتقل می‌شوند و در صورت نیاز به تماس صوتی روی مرکز تلفن ابری نواتل تبدیل می‌شوند. مکالمات در پنل نواتل آرشیو می‌شوند و به CRM نواتل متصل‌اند. هزینه سرویس ۴۵۰ هزار تومان در ماه با پرداخت سالانه است و به ازای کاربر محاسبه نمی‌شود.",
      "url": "https://navatel.ir/products/webchat/",
      "image": {
        "@id": "https://navatel.ir/products/webchat/#primaryimage"
      },
      "brand": {
        "@id": "https://navatel.ir/#organization"
      },
      "provider": {
        "@id": "https://navatel.ir/#organization"
      },
      "publisher": {
        "@id": "https://navatel.ir/#organization"
      },
      "category": "نرم‌افزار ارتباط با مشتری / چت آنلاین سایت",
      "applicationCategory": "BusinessApplication",
      "applicationSubCategory": "Live Chat Software",
      "operatingSystem": "Web, Android, iOS",
      "inLanguage": "fa",
      "audience": {
        "@type": "BusinessAudience",
        "audienceType": "کسب‌وکارهای دارای سایت؛ تیم‌های فروش، پشتیبانی و بازاریابی"
      },
      "featureList": [
        "پاسخ Real-Time به بازدیدکنندگان سایت بدون تأخیر",
        "پاسخ‌های آماده برای سوالات متداول (FAQ)",
        "ارسال تصویر، PDF و ویدئو داخل گفتگو",
        "ارسال پیام صوتی",
        "هماهنگ‌سازی ظاهر چت باکس با پالت رنگی برند",
        "نمایش لوگوی اختصاصی در بالای پنجره گفتگو",
        "پیام خوش‌آمدگویی دلخواه",
        "انتخاب موقعیت نمایش ویجت (چپ یا راست صفحه)",
        "تنظیم زبان ویجت",
        "تاریخچه مکالمات با فیلتر بر اساس سایت، دپارتمان یا اپراتور",
        "آرشیو مکالمات بدون محدودیت زمانی",
        "سه روش توزیع گفتگو بین اپراتورها: تصادفی، همزمان برای همه اپراتورها، یا کم‌کارترین اپراتور",
        "انتقال گفتگو همراه با کل تاریخچه به اپراتور یا دپارتمان تخصصی",
        "گزارش عملکرد اپراتورها شامل زمان پاسخ، تعداد گفتگو و رضایت مشتری",
        "اتصال به CRM نواتل و ثبت مکالمه در CRM",
        "انتقال گفتگو به تماس صوتی روی مرکز تلفن ابری نواتل",
        "دریافت نوتیفیکیشن پیام‌ها در اپلیکیشن نواتل روی گوشی",
        "نصب بدون کدنویسی با یک اسکریپت کوتاه، در کمتر از ۵ دقیقه",
        "بارگذاری Async ویجت بدون تأثیر بر سرعت لود صفحه",
        "پشتیبانی ۲۴/۷"
      ],
      "isRelatedTo": [
        {
          "@id": "https://navatel.ir/products/crm/#service"
        },
        {
          "@id": "https://navatel.ir/products/cloud-pbx/#service"
        }
      ],
      "offers": {
        "@type": "Offer",
        "@id": "https://navatel.ir/products/webchat/#offer",
        "url": "https://navatel.ir/products/webchat/",
        "price": "4500000",
        "priceCurrency": "IRR",
        "priceValidUntil": "2027-03-20",
        "availability": "https://schema.org/InStock",
        "businessFunction": "http://purl.org/goodrelations/v1#LeaseOut",
        "priceSpecification": {
          "@type": "UnitPriceSpecification",
          "price": "4500000",
          "priceCurrency": "IRR",
          "referenceQuantity": {
            "@type": "QuantitativeValue",
            "value": 1,
            "unitCode": "MON"
          },
          "billingDuration": "P1Y",
          "valueAddedTaxIncluded": false,
          "description": "۴۵۰ هزار تومان ماهانه، با پرداخت سالانه (۵٬۴۰۰٬۰۰۰ تومان در سال)؛ قیمت به ازای هر کاربر محاسبه نمی‌شود."
        },
        "seller": {
          "@id": "https://navatel.ir/#organization"
        },
        "areaServed": {
          "@type": "Country",
          "name": "Iran"
        }
      }
    },
    {
      "@type": "HowTo",
      "@id": "https://navatel.ir/products/webchat/#howto",
      "name": "راه‌اندازی چت آنلاین سایت نواتل در ۳ مرحله",
      "description": "بدون نیاز به کدنویسی پیچیده؛ یک وبچت حرفه‌ای در سایت خود داشته باشید.",
      "inLanguage": "fa-IR",
      "totalTime": "PT5M",
      "isPartOf": {
        "@id": "https://navatel.ir/products/webchat/#webpage"
      },
      "step": [
        {
          "@type": "HowToStep",
          "position": 1,
          "name": "ثبت‌نام و فعالسازی",
          "text": "حساب کاربری بسازید و چت آنلاین را در پنل مدیریتی فعال کنید.",
          "url": "https://navatel.ir/products/webchat/#launch-steps"
        },
        {
          "@type": "HowToStep",
          "position": 2,
          "name": "شخصی‌سازی و تنظیمات",
          "text": "رنگ، لوگو، پیام خوش‌آمدگویی و سوالات متداول را تنظیم کنید.",
          "url": "https://navatel.ir/products/webchat/#launch-steps"
        },
        {
          "@type": "HowToStep",
          "position": 3,
          "name": "نصب کد در سایت",
          "text": "یک اسکریپت کوتاه را در Header وب‌سایت جایگذاری کنید؛ تمام!",
          "url": "https://navatel.ir/products/webchat/#launch-steps"
        }
      ]
    }
  ]
}